export default __webpack_public_path__ + "static/media/Fyrskar.782d89fd.svg";